// extracted by mini-css-extract-plugin
module.exports = {"errorText":"form-error_errorText__kmHXF"};